(function () {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  var isLocal = /localhost|127\.0\.0\.1/.test(window.location.hostname);
  var CACHE_PREFIX = 'publikaya-';

  async function clearPublikayaCaches() {
    if (!window.caches || !caches.keys) {
      return;
    }

    try {
      var cacheNames = await caches.keys();
      await Promise.all(
        cacheNames
          .filter(function (name) { return name.indexOf(CACHE_PREFIX) === 0; })
          .map(function (name) { return caches.delete(name); })
      );
    } catch (_) {
      // noop
    }
  }

  async function unregisterAllServiceWorkers() {
    try {
      var registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        registrations.map(function (registration) {
          return registration.unregister().catch(function () { return false; });
        })
      );
    } catch (_) {
      // noop
    }
  }

  async function registerProductionServiceWorker() {
    try {
      var registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });

      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      registration.addEventListener('updatefound', function () {
        var worker = registration.installing;
        if (!worker) {
          return;
        }

        worker.addEventListener('statechange', function () {
          if (worker.state === 'installed' && registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          }
        });
      });
    } catch (_) {
      // noop
    }
  }

  window.addEventListener('load', function () {
    if (isLocal) {
      unregisterAllServiceWorkers().finally(clearPublikayaCaches);
      return;
    }

    registerProductionServiceWorker();
  }, { once: true });
})();
